import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAuthorizedLpSelected } from "../../actions/lp";
import { GET_AUTHORIZED_LP_SELECTED_REQUEST } from "../../actions/lp/actionTypes";
import { getAuthorizedLpSelectedSelector } from "../../actions/lp/selectors";
export function useLpSelected() {
    var dispatch = useDispatch();
    var lpSelected = useSelector(getAuthorizedLpSelectedSelector);
    useEffect(function() {
        dispatch(getAuthorizedLpSelected.request({}, GET_AUTHORIZED_LP_SELECTED_REQUEST)); // To fetch Lp that is already selected
    }, [
        dispatch
    ]);
    return lpSelected;
}

//# sourceMappingURL=useLpSelected.js.map